const styles = (theme, props) => ({
  root: {
    backgroundColor: theme.colors.eyYellow,
    borderRadius: 0,
    border: '1px solid transparent',
    color: '#000',
    height: 48,
    maxWidth: props.noMaxWidth ? 'none' : 160,
    padding: '0 20px',
    boxShadow: 'none',
    '&:hover': {
      border: `1px solid ${theme.colors.yellow1}`,
      backgroundColor: theme.colors.eyYellow,
      boxShadow: '0 0 4px 0 rgba(255,230,0,0.66)',
    },
    '&$disabled': {
      backgroundColor: theme.colors.eyGrey3,
    },
    textTransform: 'none',
  },
  label: {
    color: theme.colors.eyConfidentGrey,
    display: 'inherit',
    alignItems: 'inherit',
    justifyContent: 'inherit',
    fontWeight: 'bold',
    fontSize: '14px',
    width: '100%',
    whiteSpace: 'nowrap',
  },
  disabled: {
    backgroundColor: theme.colors.eyGrey3,
  },
  labelDisabled: {
    color: theme.colors.eyGrey6,
    display: 'inherit',
    alignItems: 'inherit',
    justifyContent: 'inherit',
    fontWeight: 'bold',
    fontSize: '14px',
    width: '100%',
  },
});

export default styles;
